//gsap

document.addEventListener('DOMContentLoaded', function () {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  if (typeof gsap !== 'undefined') {
    const tl = gsap.timeline();

    tl.to(".cover", {
      autoAlpha: 1,
      scale: 1,
      duration: 2,
      ease: "power3.out"
    });

    tl.to(".fadin", {
      autoAlpha: 1,
      duration: 0.8,
      stagger: 0.2,
      ease: "power1.inOut"
    }, "-=1");
  }

  const scene = document.getElementById('scene');
  if (scene && typeof Parallax !== 'undefined') {
    new Parallax(scene, {
      calibrateX: true
    });
  }
});

  document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const target = document.querySelector(this.getAttribute('href'));
      if (!target) return;

      target.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    });
  });

});